import { render } from "./RegionsConfigsLotteries.vue?vue&type=template&id=3d0bfa32&scoped=true"
import script from "./RegionsConfigsLotteries.vue?vue&type=script&lang=js"
export * from "./RegionsConfigsLotteries.vue?vue&type=script&lang=js"

import "./RegionsConfigsLotteries.vue?vue&type=style&index=0&id=3d0bfa32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0bfa32"]])

export default __exports__